import { readsApi } from './api';
import type { DashboardStats } from '@apptypes/index';

// All analytics endpoints are read-only → FastAPI :8000
export const analyticsService = {
  getDashboard: () =>
    readsApi.get<DashboardStats>('/analytics/dashboard'),

  getRevenue: (params?: { startDate?: string; endDate?: string; interval?: string }) =>
    readsApi.get('/analytics/financial', params as Record<string, unknown>),

  getMerchants: (params?: { limit?: number }) =>
    readsApi.get('/analytics/merchants', params as Record<string, unknown>),

  getOrderTrends: (params?: { period?: string }) =>
    readsApi.get('/analytics/orders', params as Record<string, unknown>),

  getDeliveryMetrics: () =>
    readsApi.get('/analytics/delivery'),
};
